import React from "react";
import ChangeRequestSideBarContent from "src/components/Form/ChangeRequest/ChangeRequestSideBarContent";

export const SidebarSection = () => <ChangeRequestSideBarContent />;
